module.exports = __webpack_public_path__ + "f1abd33a7f88de2ae62ec04ee7f877e8.svg";